<div class="background">
  {{ 'acceptInvitation.progress' | translate }}
</div>